import { createSlice,createAsyncThunk } from "@reduxjs/toolkit";
import { BASE_URL_SANDBOX ,  GET_ORDER_SUMMERY_DETAILS} from '../../../Constants/Config'
import axios from 'axios'

const initialState={
    loading:false,
    orderSummeryDetails:{},
    error:'',
    isOrderSummaryInitial: true,
    requestKey: '',
    activeRequestKey: '',
    activeRequestId: null,
}

export const createOrderSummaryRequestKey = (data) => {
  const merchantId = String(data?.merchant_id ?? '').trim().toUpperCase();
  const orderId = String(data?.order_id ?? '').trim();

  return merchantId && orderId
    ? JSON.stringify([merchantId, orderId])
    : '';
};
// import { createAsyncThunk } from '@reduxjs/toolkit';
// import axios from 'axios';

export const FetchOrderSummeryDetails = createAsyncThunk('orderSummeryDetails/FetchOrderSummeryDetails', async (data, { rejectWithValue }) => {
  try {
    const response = await axios.post(BASE_URL_SANDBOX +  GET_ORDER_SUMMERY_DETAILS, data, { headers: { "Content-Type": "multipart/form-data" } })
    if(response.data.status === true)
    {
       return response.data.result
    }
    return rejectWithValue({
      message: response?.data?.message || 'Unable to load order details',
    });
  } catch (error) {
    return rejectWithValue({
      message:
        error?.response?.data?.message ||
        error?.message ||
        'Unable to load order details',
    });
  }
});

// export const FetchOrderSummeryDetails = createAsyncThunk('orderSummeryDetails/FetchOrderSummeryDetails', async (data) => {
//     const response = await axios.post(
//         'https://sandbox.quickvee.com/MyOrder/detailsNew',
//         data,
//         { headers: { "Content-Type": "multipart/form-data" } }
//       );
  
//     // if (response.data.status === 200) {
//     //     return response.data.result
//     // }
// })

// export const FetchOrderSummeryDetails=createAsyncThunk('orderSummeryDetails/FetchOrderSummeryDetails',async(data)=>{
//     const response= await axios.post(BASE_URL_SANDBOX + GET_ORDER_SUMMERY_DETAILS,data, { headers: { "Content-Type": "multipart/form-data" } });
// })
const orderSummerySlice = createSlice({
    name: 'orderSummeryDetails',
    initialState,
    reducers: {
      setOrderSummaryInitialFalse: (state) => {
        state.isOrderSummaryInitial = false;
      },
      setOrderSummaryInitialTrue: (state) => {
        state.isOrderSummaryInitial = true;
      }
    },
    extraReducers: (builder) => {
        builder.addCase(FetchOrderSummeryDetails.pending, (state, action) => {
            const requestKey = createOrderSummaryRequestKey(action.meta?.arg);
            if (!requestKey || !action.meta?.requestId) {
                state.loading = false;
                state.orderSummeryDetails = {};
                state.error = 'Unable to identify this order';
                state.requestKey = '';
                state.activeRequestKey = '';
                state.activeRequestId = null;
                return;
            }

            if (state.requestKey !== requestKey) {
                state.orderSummeryDetails = {};
                state.requestKey = '';
            }
            state.loading = true;
            state.error = '';
            state.activeRequestKey = requestKey;
            state.activeRequestId = action.meta.requestId;
        })
        builder.addCase(FetchOrderSummeryDetails.fulfilled, (state, action) => {
            const requestKey = createOrderSummaryRequestKey(action.meta?.arg);
            if (
                action.meta?.requestId !== state.activeRequestId ||
                requestKey !== state.activeRequestKey
            ) {
                return;
            }

            state.loading = false;
            state.orderSummeryDetails = action.payload || {};
            state.error = '';
            state.requestKey = requestKey;
            state.activeRequestKey = '';
            state.activeRequestId = null;
        })
        builder.addCase(FetchOrderSummeryDetails.rejected, (state, action) => {
            const requestKey = createOrderSummaryRequestKey(action.meta?.arg);
            if (
                action.meta?.requestId !== state.activeRequestId ||
                requestKey !== state.activeRequestKey
            ) {
                return;
            }

            state.loading = false;
            state.orderSummeryDetails = {};
            state.error =
              action.payload?.message ||
              action.error?.message ||
              'Unable to load order details';
            state.requestKey = '';
            state.activeRequestKey = '';
            state.activeRequestId = null;
        })
    }
})

export const {  setOrderSummaryInitialFalse, setOrderSummaryInitialTrue } = orderSummerySlice.actions;
export default orderSummerySlice.reducer
